// PDP info box (facts card, features, description, specifications) — shared by
// Amazon and Best Buy products. Every toggle only reveals server-rendered content
// so the page stays indexable; masonry is relaid out after each height change.
// Reuse storefront jQuery so Webpack does not replace its registered plugins.
(function ($) {
  if (window.ProductInfo) return;

  function relayout() {
    if (!$ || !$.fn.masonry) return;
    $('.grid').each(function () {
      if ($(this).data('masonry')) $(this).masonry('layout');
    });
  }

  function setToggle(button, expanded) {
    button.setAttribute('aria-expanded', String(expanded));
    button.textContent = expanded ? button.dataset.less : button.dataset.more;
  }

  function expanded(button) {
    return button.getAttribute('aria-expanded') === 'true';
  }

  // "Show all N" reveals the [data-pi-extra] items of its target; "Read more"
  // lifts the target's clamp and only appears when the text actually overflows
  function initToggles(root, clamps) {
    root.querySelectorAll('[data-pi-toggle]').forEach(function (button) {
      const target = document.getElementById(button.getAttribute('aria-controls'));
      if (!target) return;
      const clamp = button.dataset.piToggle === 'clamp';
      if (clamp) clamps.push({ button: button, target: target });
      button.addEventListener('click', function () {
        const open = !expanded(button);
        if (clamp) target.classList.toggle('is-clamped', !open);
        else target.querySelectorAll('[data-pi-extra]').forEach(function (el) { el.hidden = !open; });
        setToggle(button, open);
        relayout();
      });
    });
  }

  function fitClamp(clamp) {
    if (expanded(clamp.button)) return;
    clamp.target.classList.add('is-clamped');
    const overflows = clamp.target.scrollHeight > clamp.target.clientHeight + 1;
    clamp.button.hidden = !overflows;
    if (!overflows) clamp.target.classList.remove('is-clamped');
  }

  // Facts rows keep to one line: lists show as many items as fit plus "+N more",
  // sentences get an ellipsis; both expand in place
  function initFacts(root) {
    const facts = Array.from(root.querySelectorAll('[data-pi-fact]'));
    facts.forEach(function (fact) {
      fact.querySelector('[data-pi-fact-toggle]').addEventListener('click', function () {
        fact.classList.toggle('is-expanded');
        if (fact.classList.contains('is-expanded')) expandFact(fact);
        else fitFact(fact);
        relayout();
      });
    });
    return facts;
  }

  function expandFact(fact) {
    fact.querySelectorAll('[data-pi-fact-item]').forEach(function (item) { item.hidden = false; });
    setToggle(fact.querySelector('[data-pi-fact-toggle]'), true);
  }

  function fitFact(fact) {
    const value = fact.querySelector('[data-pi-fact-value]');
    const button = fact.querySelector('[data-pi-fact-toggle]');
    const items = Array.from(fact.querySelectorAll('[data-pi-fact-item]'));
    setToggle(button, false);
    button.hidden = true;
    if (!items.length) {
      value.classList.add('is-clamped');
      button.hidden = value.scrollWidth <= value.clientWidth;
      return;
    }
    value.classList.remove('is-clamped');
    items.forEach(function (item) { item.hidden = false; });
    const top = items[0].getBoundingClientRect().top;
    // an inline item may start on the first line and still wrap, so test its last fragment
    const wraps = function (item) {
      const rects = item.getClientRects();
      return rects.length > 0 && rects[rects.length - 1].top > top + 1;
    };
    let shown = items.findIndex(wraps);
    if (shown === -1) return;
    // hide from the first wrapped item on, then keep trimming until what is left shares the line with the link
    button.hidden = false;
    shown = Math.max(shown, 1);
    for (;;) {
      items.forEach(function (item, index) { item.hidden = index >= shown; });
      button.textContent = items.length === 1 ? button.dataset.more : '+' + (items.length - shown) + ' more';
      if (shown === 1 || !items.slice(0, shown).some(wraps)) break;
      shown -= 1;
    }
    // a lone item longer than the line gets an ellipsis instead of wrapping
    value.classList.toggle('is-clamped', shown === 1);
  }

  // Eight rows by default; searching filters every row live and ignores the cap
  function initSpecs(root) {
    const section = root.querySelector('[data-pi-specs]');
    if (!section) return;
    const rows = Array.from(section.querySelectorAll('[data-pi-spec]')).map(function (row) {
      return { el: row, extra: row.hasAttribute('data-pi-extra'), text: row.textContent.replace(/\s+/g, ' ').toLowerCase() };
    });
    const count = section.querySelector('[data-pi-specs-count]');
    const status = section.querySelector('[data-pi-specs-status]');
    const empty = section.querySelector('[data-pi-specs-empty]');
    const toggle = section.querySelector('[data-pi-specs-toggle]');
    const search = section.querySelector('[data-pi-spec-search]');
    const clear = section.querySelector('.pi-search__clear');
    let open = false;

    function render() {
      const query = search ? search.value.trim().toLowerCase() : '';
      let shown = 0;
      rows.forEach(function (row) {
        const visible = query ? row.text.indexOf(query) !== -1 : open || !row.extra;
        row.el.hidden = !visible;
        if (!visible) return;
        row.el.classList.toggle('is-alt', shown % 2 === 1);
        shown += 1;
      });
      count.textContent = query ? shown + ' of ' + rows.length : String(rows.length);
      status.textContent = query ? shown + ' of ' + rows.length + ' specs shown' : '';
      empty.hidden = !query || shown > 0;
      if (toggle) {
        toggle.hidden = !!query;
        setToggle(toggle, open);
      }
      if (clear) clear.hidden = !query;
      requestAnimationFrame(relayout);
    }

    if (toggle) toggle.addEventListener('click', function () { open = !open; render(); });
    if (search) {
      search.addEventListener('input', render);
      search.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        search.value = '';
        render();
      });
      section.querySelectorAll('[data-pi-spec-clear]').forEach(function (button) {
        button.addEventListener('click', function () {
          search.value = '';
          render();
          search.focus();
        });
      });
    }
    render();
  }

  function initialize() {
    const root = document.querySelector('[data-product-info]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const clamps = [];
    initToggles(root, clamps);
    const facts = initFacts(root);
    initSpecs(root);

    // measured layout: redo it once fonts land and whenever the width changes
    let width = window.innerWidth;
    const refit = function () {
      clamps.forEach(fitClamp);
      facts.forEach(function (fact) { if (!fact.classList.contains('is-expanded')) fitFact(fact); });
      relayout();
    };
    refit();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(refit);
    let frame;
    window.addEventListener('resize', function () {
      if (window.innerWidth === width) return; // iOS fires resize as the URL bar collapses
      width = window.innerWidth;
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(refit);
    });
  }

  window.ProductInfo = { initialize: initialize };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})(window.jQuery);
